var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Welcome","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"className":"close-stroke","id":"Desktop-HD-DARK","transform":"translate(-1400 -860)"},React.createElement("g",{"id":"Mobile---X","transform":"translate(1402 862)"},React.createElement("g",{"id":"Group"},React.createElement("path",{"id":"Line","strokeWidth":"3","d":"M.4906 19.7084L19.5094.6897M19.5094 19.7084L.4906.6896"}))))));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
